/**
 * @desc bill 公共 + 表单
 */
import { trackEvent } from '@/omega/index';

export const bill_view_log = () => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_common_sw',
    eventLabel: '下单页曝光事件',
  });
};

export const bill_time_tips_sw = () => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_unbusinesshours_block_sw',
    eventLabel: '下单页非营业时间常驻曝光事件',
  });
};

export const bill_time_pup_tips_sw = (event_type) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_unbusinesshours_popup_sw',
    eventLabel: '下单页非营业时间弹窗曝光',
    attrs: {
      event_type,
    },
  });
};

export const bill_time_pup_tips_ck = (event_type) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_unbusinesshours_popup_ck',
    eventLabel: '下单页非营业时间弹窗点击',
    attrs: {
      event_type,
    },
  });
};

export const bill_pick_up_sw = (payload) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_sender_common_sw',
    eventLabel: '下单页寄件人信息曝光',
    attrs: {
      ...payload,
    },
  });
};

export const bill_pick_up_ck = (payload) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_sender_common_ck',
    eventLabel: '下单页寄件人点击事件',
    attrs: {
      ...payload,
    },
  });
};

export const bill_drop_off_sw = (payload) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_reciever_common_sw',
    eventLabel: '下单页收件人信息曝光',
    attrs: {
      ...payload,
    },
  });
};

export const bill_drop_off_goods_type_ck = (payload) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_reciever_goods_type_ck',
    eventLabel: '下单页收件人物品类型点击',
    attrs: {
      ...payload,
    },
  });
};
export const bill_drop_off_goods_weight_ck = (payload) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_reciever_goods_weight_ck',
    eventLabel: '下单页收件人物品重量选择',
    attrs: {
      ...payload,
    },
  });
};

export const bill_drop_off_ck = (payload) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_reciever_common_ck',
    eventLabel: '下单页收件人点击事件',
    attrs: {
      ...payload,
    },
  });
};

export const bill_drop_off_his_sw = (payload) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_history_list_sw',
    eventLabel: '下单页收件人历史地址',
    attrs: {
      ...payload,
    },
  });
};

export const bill_drop_off_his_ck = (payload) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_reciever_history_result_ck',
    eventLabel: '历史地址列表点击事件',
    attrs: {
      ...payload,
    },
  });
};
export const bill_drop_off_order_ck = (payload) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_reciever_delete_popup_ck',
    eventLabel: '下单页收件人删除弹窗点击',
    attrs: {
      ...payload,
    },
  });
};

export const bill_drop_off_add_ck = (payload) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_reciever_add_ck',
    eventLabel: '下单页收件人添加收件按钮点击',
    attrs: {
      ...payload,
    },
  });
};

export const bill_poi_check_err_sw = (payload) => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_address_check_sw',
    eventLabel: '下单页地址校验错误信息提示曝光',
    attrs: {
      ...payload,
    },
  });
};
